import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Col, Dropdown, Form, Spinner} from "react-bootstrap";
import {
    fetchPrices,
    updatePrice
} from "../../../http/bookAPI";
import Modal from "react-bootstrap/Modal";
import {Context} from "../../../index";
import {observer} from "mobx-react-lite";
import Row from "react-bootstrap/Row";

const UpdatePrice = observer(({ show, handleClose }) => {
    const [discount, setDiscount] = useState("");
    const [discountStart, setDiscountStart] = useState("");
    const [discountEnd, setDiscountEnd] = useState("");

    const [bonus, setBonus] = useState("");
    const [bonusStart, setBonusStart] = useState("");
    const [bonusEnd, setBonusEnd] = useState("");

    const [price, setPrice] = useState("");
    const [priceLibrary, setPriceLibrary] = useState("");
    const [priceCreating, setPriceCreating] = useState("");
    const [priceAdd, setPriceAdd] = useState("");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const { book } = useContext(Context);


    // ✅ Загружаем список цен при открытии модального окна
    useEffect(() => {
        if (show) {
            fetchPrices().then(data => book.setPrices(data));
        }
    }, [show]);

    // ✅ Очистка полей после обновления или закрытия окна
    const resetFields = () => {
        book.setSelectedPrice({});
        setDiscount("");
        setDiscountStart("");
        setDiscountEnd("");
        setBonus("");
        setBonusStart("");
        setBonusEnd("");
        setPrice("");
        setPriceCreating("");
        setPriceLibrary("");
        setPriceAdd("");
    };

    // ✅ Оптимизированная функция обновления акций
    const modifyPromotion = useCallback(async () => {
        if (!book?.selectedPrice?.id) {
            setError("Please select a price to modify.");
            return;
        }

        setLoading(true);
        setError("");
        try {
            await updatePrice({
                id: book?.selectedPrice?.id,
                price: price || 0,
                price_for_show_in_library: priceLibrary || 0,
                price_for_creating: priceCreating || 0,
                price_addition: priceAdd || 0,
                promotion_price_discount: discount || 0,
                promotion_price_discount_start_date: discountStart ? Math.floor(new Date(discountStart).getTime()) : null,
                promotion_price_discount_end_date: discountEnd ? Math.floor(new Date(discountEnd).getTime()) : null,
                promotion_price_bonus: bonus || 0,
                promotion_price_bonus_start_date: bonusStart ? Math.floor(new Date(bonusStart).getTime()) : null,
                promotion_price_bonus_end_date: bonusEnd ? Math.floor(new Date(bonusEnd).getTime()) : null,
            });

            const updatedPrices = await fetchPrices();
            book.setPrices(updatedPrices);
            resetFields();
            handleClose();
        } catch (e) {
            setError(e.response?.data?.message || "An error occurred while modifying the promotion.");
        } finally {
            setLoading(false);
        }
    }, [book, discount, discountStart, discountEnd, bonus, bonusStart, bonusEnd]);


    return (
        <Modal size="lg" show={show} onHide={() => { setError(""); resetFields(); handleClose(); }} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5">Edit Promotions:</h1>
                    <button type="button" className="btn-close" onClick={() => { setError(""); resetFields(); handleClose(); }}></button>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-center mt-1">
                            <Dropdown className="dropdown-center">
                                <Dropdown.Toggle variant="success" className="shadow">
                                    {book?.selectedPrice?.price || "Select Price to Modify"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {book?.prices?.map((pr) => (
                                        <Dropdown.Item
                                            key={pr.id}
                                            onClick={() => {
                                                book.setSelectedPrice(pr);
                                                setDiscount(pr.promotion_price_discount);
                                                setDiscountStart(pr.promotion_price_discount_start_date);
                                                setDiscountEnd(pr.promotion_price_discount_end_date);
                                                setBonus(pr.promotion_price_bonus);
                                                setBonusStart(pr.promotion_price_bonus_start_date);
                                                setBonusEnd(pr.promotion_price_bonus_end_date);
                                                setPrice(pr.price);
                                                setPriceLibrary(pr.price_for_show_in_library);
                                                setPriceCreating(pr.price_for_creating);
                                                setPriceAdd(pr.price_addition);
                                            }}
                                        >
                                            {pr.price}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>

                {error && <div className="alert alert-danger mx-3">{error}</div>}
<Row>
    <Col md={6}>
        <div className="modal-body">
            <div className="row">
                <div className="col-md-6">
           <Form className="mb-2">
               <div className="small ms-1 mt-1 mb-0 p-0">Price:</div>
            <Form.Control

                value={price}
                onChange={(e) => setPrice(e.target.value)}
                disabled={loading || !book?.selectedPrice?.id}
            />
        </Form>
                </div>

                <div className="col-md-6">
            <div className="small ms-1 mt-1 mb-0 p-0">Price for Show in Library:</div>
            <Form className="mb-2">
            <Form.Control
                value={priceLibrary}
                onChange={(e) => setPriceLibrary(e.target.value)}
                disabled={loading || !book?.selectedPrice?.id}
            />
        </Form>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
            <div className="small ms-1 mt-1 mb-0 p-0">Price for Creating:</div>
            <Form className="mb-2">
            <Form.Control
                value={priceCreating}
                onChange={(e) => setPriceCreating(e.target.value)}
                disabled={loading || !book?.selectedPrice?.id}
            />
        </Form>
                </div>

                    <div className="col-md-6">
            <div className="small ms-1 mt-1 mb-0 p-0">Price Addition:</div>
            <Form className="mb-2">
            <Form.Control
                value={priceAdd}
                onChange={(e) => setPriceAdd(e.target.value)}
                disabled={loading || !book?.selectedPrice?.id}
            />
        </Form>
                    </div>
            </div>
  </div>
        <div className="mt-3 p-4">
            <img
                src="./Virtalibry_logo_sub_no_bg.png"
                alt="Virtalibry Logo"
                width="305"
                height="47"
                className="d-flex align-top ms-3"
            />

        </div>

    </Col>
    <Col md={6}>
        <div className="modal-body">
            <div className="small ms-1 mt-1 mb-0 p-0">Update Promotion Discount:</div>
            <Form className="mb-2">
                <Form.Control
                    type="number"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                    disabled={loading || !book?.selectedPrice?.id}
                />
            </Form>

            <div className="row">
                <div className="col-md-6">
                    <div className="small ms-1 mt-1 mb-0 p-0">Discount Start Date:</div>
                    <Form className="mb-2">
                    <Form.Control
                        type="date"
                        value={discountStart ? new Date(discountStart * 60000).toISOString().split("T")[0] : ""}
                        onChange={(e) => setDiscountStart(Math.floor(Date.parse(e.target.value) / 60000))}
                        disabled={loading || !book?.selectedPrice?.id}
                    />
                    </Form>
                </div>

                <div className="col-md-6">
                    <div className="small ms-1 mt-1 mb-0 p-0">Discount End Date:</div>
                    <Form className="mb-2">
                    <Form.Control
                        type="date"
                        value={discountEnd ? new Date(discountEnd * 60000).toISOString().split("T")[0] : ""}
                        onChange={(e) => setDiscountEnd(Math.floor(Date.parse(e.target.value) / 60000))}
                        disabled={loading || !book?.selectedPrice?.id}
                    />
                    </Form>
                </div>
            </div>

            <div className="small ms-1 mt-1 mb-0 p-0">Update Promotion Bonus:</div>
            <Form className="mb-2">
                <Form.Control
                    type="number"
                    value={bonus}
                    onChange={(e) => setBonus(e.target.value)}
                    disabled={loading || !book?.selectedPrice?.id}
                />
            </Form>

            <div className="row">
                <div className="col-md-6">
                    <div className="small ms-1 mt-1 mb-0 p-0">Bonus Start Date:</div>
                    <Form className="mb-2">
                    <Form.Control
                        type="date"
                        value={bonusStart ? new Date(bonusStart * 60000).toISOString().split("T")[0] : ""}
                        onChange={(e) => setBonusStart(Math.floor(Date.parse(e.target.value) / 60000))}
                        disabled={loading || !book?.selectedPrice?.id}
                    />
                    </Form>
                </div>

                <div className="col-md-6">
                    <div className="small ms-1 mt-1 mb-0 p-0">Bonus End Date:</div>
                    <Form className="mb-2">
                    <Form.Control
                        type="date"
                        value={bonusEnd ? new Date(bonusEnd * 60000).toISOString().split("T")[0] : ""}
                        onChange={(e) => setBonusEnd(Math.floor(Date.parse(e.target.value) / 60000))}
                        disabled={loading || !book?.selectedPrice?.id}
                    />
                    </Form>
                </div>
            </div>
        </div>

        </Col>

</Row>


                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => { setError(""); resetFields(); handleClose(); }} disabled={loading}>
                        Close
                    </button>
                    <button type="button" className="btn btn-success" onClick={modifyPromotion} disabled={loading}>
                        {loading ? <Spinner as="span" animation="border" size="sm" /> : "Write in DB and Close"}
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default UpdatePrice;